console.log("=================== Protection App Starts ====================");
  let button = document.querySelector(".c_p-appbtn button");
  let secure = document.querySelector("#secure");
  let theForm = document.querySelector('.product-form__buy-buttons form');
  let thePrice = document.querySelector('.c_picnwtxt-price');
let title = document.querySelector('.product-meta__title .product-meta__title-span').textContent;
  button.addEventListener('click', (e)=>{
      e.preventDefault();
      e.stopPropagation();
      console.log(secure.checked, secure.value, Number(parseFloat(thePrice.textContent.split('$')[1]).toFixed(2)));
    
      let productPrice = Number(parseFloat(thePrice.textContent.split('$')[1]).toFixed(2)) || 100.0;
      // Data to send in the POST request
      const data = {
        title: title + ' Casa Protection',
        price: productPrice,
        vendor: "casa-protection"
      };
      
      // POST request URL
      const herokuUrl = 'https://protection-plan-bacf3a3e23cc.herokuapp.com/api/shopify/product_create';
      
      // POST request headers
      const headers = {
        'Content-Type': 'application/json'
      };
      
      // POST request options
      const options = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data)
      };
      if(secure.checked){
        // Sending the POST request
        $(".c_p-appbtn button").attr("aria-busy", "true");
        fetch(herokuUrl, options)
        .then(response => response.json())
        .then(result => {
         console.log('Response:', result);
          if(result?.status == 200){
            let variantId = result?.data?.id;
            console.log("c---", variantId);
            //Ajax Cart add for the new protection product
            let formData = {
             'items': [{
              'id': variantId,
              'quantity': 1
              }]
            };
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
            })
            .then(res => res.json())
            .then(data => {
               console.log("Cart Add Response====>>>>>",data);
              $.ajax({
              type: 'POST', 
              url: '/cart/add.js',
              dataType: 'json', 
              data: $(".product-form__buy-buttons .shopify-product-form").serialize(),
              beforeSend: function() {
                  console.log('before enter');
                },
                success:function(cart){ 
                  console.log("sccess");
                  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
                  $(".header__icon-wrapper[aria-controls='mini-cart']").attr("aria-expanded" , "true");
                }, 
                error:function(err){
                  console.log("Error");
                   let error = JSON.parse(err.responseText);
                  alertify.set('notifier','position', 'bottom-left');
                  alertify.error(error.description); 
                },complete:function(cart){
                  console.log("complete");
                }
           });
            })
            .catch((error) => {
              console.error('Error:', error);
            });
            setTimeout(function() {
            $(".c_p-appbtn button").attr("aria-busy", "false");
            }, 500);
          }
          //If Product is not available or created by the app
          else{
            
          }
        })
        .catch(error => {
         console.error('Error:', error);
          setTimeout(function() {
$(".c_p-appbtn button").attr("aria-busy", "false");
              }, 500);
        });
      }
  });

console.log("=================== Protection App Ends ====================");